/*
 * @Author: your name
 * @Date: 2021-12-02 14:28:33
 * @LastEditTime: 2024-12-17 15:26:25
 * @LastEditors: zhangyuan your_email
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /report-template/src/store/mutation.ts
 */
import types from './mutation-types'
import {State} from './state'

export default {
    [types.SAVE_PHOTO_INFO](state: State, payload: any): void {
        state.photoInfo = payload;
    },
    [types.SAVE_DATA_INFO](state: State, payload: any): void {
        state.dataInfo = payload;
    },
    [types.SAVE_REPORT_DETECT_VERSION](state: State, payload: any): void {
        state.reportDetectVersion = payload;
    },
    [types.SAVE_IS_DISPLAY](state: State, payload: any): void {
        state.isDisplay = payload
    },
    [types.SAVE_OPACITY_STYLE](state: State, payload: any): void {
        state.opacityStyle = payload
    },
    [types.SAVE_CHECK_ITEM_SHOW](state: State, payload: any): void {
        state.checkItemShow = payload
    },
    [types.SAVE_IDLE_FISH_INFO](state: State, payload: any): void {
        state.idleFishInfo = payload
    },
    [types.SAVE_TOCONLYSHOWFLAW](state: State, payload: any): void {
        state.tocOnlyShowFlaw = payload
    },
    [types.SAVE_PAGESCROLLTOP](state: State, payload: any): void {
        state.pageScrollTop = payload
    },
     // 存储c端检测报告是否为三非
     [types.SAVE_ISNORMAL](state: State, payload: any) {
        state.isNormal = payload;
    },
    // 存储c端检测报告结论
    [types.SAVE_REPORTRESULTLIST](state: State, payload: any): void {
        state.reportResultList = payload;
    },
    // 存储c端检测报告结论
    [types.SAVE_VERSION240530](state: State, payload: any): void {
        state.version240530 = payload;
    },
    [types.SAVE_VERSION240702](state: State, payload: any): void {
        state.version240702 = payload;
    },
    [types.SAVE_VERSION240704](state: State, payload: any): void {
        state.version240704 = payload;
    },
    [types.SAVE_VERSION240326](state: State, payload: any): void {
        state.version240326 = payload;
    },
    [types.SAVE_VERSION241226](state: State, payload: any): void {
        state.version241226 = payload;
    },
    [types.SAVE_VERSION250218](state: State, payload: any): void {
        state.version250218 = payload;
    },
}
